import { graphql } from "@/graphql/codegen"
import "./customerPurchaseOrderFragments"

graphql(`
  mutation CreateCustomerPurchaseOrder($input: CustomerPurchaseOrderCreateInput!) {
    customerPurchaseOrder {
      create(input: $input) {
        __typename
        ... on CustomerPurchaseOrderCreateSuccess {
          customerPurchaseOrder {
            ...CustomerPurchaseOrderBaseFields
          }
        }
        ... on CustomerPurchaseOrderCreateFailure {
          error {
            message
            isDuplicate
            existingCustomerPurchaseOrder {
              ...CustomerPurchaseOrderBaseFields
            }
          }
        }
      }
    }
  }

  mutation DeleteCustomerPurchaseOrder($input: CustomerPurchaseOrderDeleteInput!) {
    customerPurchaseOrder {
      delete(input: $input) {
        __typename
        ... on CustomerPurchaseOrderDeleteSuccess {
          isSuccessful
        }
        ... on CustomerPurchaseOrderDeleteFailure {
          error {
            message
          }
        }
      }
    }
  }

  mutation UpsertCustomerPurchaseOrderProducts($input: CustomerPurchaseOrderUpsertProductsInput!) {
    customerPurchaseOrder {
      upsertProducts(input: $input) {
        __typename
        ... on CustomerPurchaseOrderUpsertProductsSuccess {
          customerPurchaseOrder {
            customerPurchaseOrderId
            products {
              ...CustomerPurchaseOrderProductFields
            }
          }
        }
        ... on CustomerPurchaseOrderUpsertProductsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
